import { HuvudkategoriTyp } from './HuvudkategoriTyp';

/**
 * Objektrepresentation för en definierad huvudgrupptyp). Används i syfte att filtrera huvudkategorier.
 */
export interface HuvudgruppTyp {
  /**
   * example: 1
   * Anger stabil identitet för huvudgrupptypen.
   */
  huvudgrupptyp_id: number;

  /**
   * example: ENSKILT_BEBYGGELSEOBJEKT
   * Anger typen av huvudgrupp.
   */
  huvudgrupptyp: Huvudgrupp.HuvudgrupptypEnum;

  /**
   * example: AREELLA NÄRINGAR
   * Anger namnet för huvudgrupptypen (lämpligt för presentation).
   */
  namn: string;

  /**
   * example: Areella näringar är en gruppering av ...
   * Anger beskrivning för huvudgruppen. (Lämpligt för hjälptext).
   */
  beskrivning: string;

  /**
   * example: true
   * Anger om typen är aktiv (true) och kan användas vid registrering.
   */
  aktiv: boolean;

  /**
   * example: 10
   * Anger sorteringsordningen för typen.
   */
  sorteringsordning: number;

  huvudkategorier: Array<HuvudkategoriTyp>;
}

export namespace Huvudgrupp {
  export type HuvudgrupptypEnum = 'ENSKILT_BEBYGGELSEOBJEKT' | 'OMRADE';
  export const HuvudgrupptypEnum = {
    ENSKILTBEBYGGELSEOBJEKT: 'ENSKILTBEBYGGELSEOBJEKT' as HuvudgrupptypEnum,
    OMRADE: 'OMRADE' as HuvudgrupptypEnum
  };
}
